import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { TeamSchema } from './teams';
import { UserSchema } from './users';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

const TeamUserRoleSchema = z.enum(['admin', 'member']);

export const TeamUserRoleToLabelMap: Record<TeamUserRole, string> = {
  admin: 'Admin',
  member: 'Member',
};

export type TeamUserRole = z.infer<typeof TeamUserRoleSchema>;

export const TeamUserSchema = z.object({
  teamUserId: PrimaryKeySchema,
  teamId: TeamSchema.shape.teamId,
  userId: UserSchema.shape.userId,
  role: TeamUserRoleSchema,
  isDefault: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type TeamUser = z.infer<typeof TeamUserSchema>;

export const TeamUsersSchema = z.array(TeamUserSchema);

export type TeamUsers = z.infer<typeof TeamUsersSchema>;

export const TeamUserFiltersSchema = z
  .object({
    teamUserIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    teamIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    userIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    roles: commaDelimitedList(TeamUserRoleSchema.array()).optional(),
    nameLike: z.string().optional(),
    emailLike: z.string().optional(),
  })
  .merge(
    createOffsetPaginationRequestQuerySchema(
      z.enum(['name', 'role', 'createdAt', 'updatedAt']),
    ),
  );

export type TeamUserFilters = z.infer<typeof TeamUserFiltersSchema>;

export const UpdateTeamUserSchema = z.object({
  isDefault: z.boolean().optional(),
});

export type UpdateTeamUser = z.infer<typeof UpdateTeamUserSchema>;
